<script setup>
import { computed } from 'vue';
import { isSuperAdmin } from '../helpers';
import { useStore } from 'vuex';

const store = useStore();

const authuser = computed(() => store.state.user);
</script>

<template>
  <div class="containerd-flex align-items-center justify-content-center">
    <div class="text-center">
      <h1 class="display-1 text-danger fw-bold">403</h1>
      <h2 class="display-6 mb-4">Access Denied</h2>
      <p class="lead mb-4">You don't have permission to access this page.</p>
      <p class="lead mb-4" v-if="!isSuperAdmin(authuser)"><strong>Please select a location that has speq portal invite.</strong></p>
      <router-link to="/" class="btn btn-primary px-4">
        Return to Home
      </router-link>
    </div>
  </div>
 </template>